<template>
  <SidebarComponent /> <!-- Aggiungi il componente sidebar qui -->
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <!-- Titolo -->
        <div class="titolo-card">
          <h1>Blocca gli slot</h1>
        </div>
      </div>
      <!-- Cicla sui giorni -->
      <div v-for="(slots, date) in slotsByDate" :key="date" class="card-black-orders">
        <div class="card-header2" @click="toggleAccordion(date)">
          <div class="icon-column">
            <span class="material-icons">
              {{ currentAccordion === date ? 'expand_less' : 'expand_more' }}
            </span>
          </div>
          <div class="text-column">
            <div class="header-text">
  {{ formattaData(date) }} 
  <span v-if="calcolaSlotLiberi(slots) === 0" class="sold-out">SOLD OUT</span>
  <span v-else class="slots-prenotati">Slot liberi: {{ calcolaSlotLiberi(slots) }} / 63</span>
</div>

          </div>
        </div>
        <!-- Mostra gli slot di quel giorno se l'accordion è aperto -->
        <div v-if="currentAccordion === date && slots.length > 0" class="order-details">
          <div class="slot-grid">
            <button @click="bloccaGiorno1slot(date)" class="prenota-tutto">Blocca 1 Slot</button>
            <button @click="bloccaFasciaOraria1slot(date)" class="blocca-fascia-oraria">Blocca 1 Slot (08:00-11:30)</button>
            <!-- Bottone per bloccare l'intero giorno -->
            <button @click="bloccaGiornoIntero(date)" class="blocca-giorno">Blocca Giorno Intero</button>
            <!-- Bottone per cancellare tutte le prenotazioni del giorno -->
            <button @click="cancellaPrenotazioniGiorno(date)" class="cancella-giorno">Cancella tutti gli slot</button>

            <div class="slot-grid-row" v-for="slot in slots" :key="slot.time">
  <div class="slot-grid-column">{{ slot.time }}</div>
  <div class="slot-grid-column">
  <button v-if="slot.isBooked[1]" 
          @click="mostraModale(date, slot.time, 1)" 
          :class="slot.isSpecial[1] ? 'slot-prenotato-special' : 'slot-prenotato'">
    1
  </button>
  <button v-else 
          @click="showAssignModal = true; prepareSlotForAssignment(date, slot.time, 1)" 
          class="slot-libero">
    1
  </button>
</div>
<div class="slot-grid-column">
  <button v-if="slot.isBooked[2]" 
          @click="mostraModale(date, slot.time, 2)" 
          :class="slot.isSpecial[2] ? 'slot-prenotato-special' : 'slot-prenotato'">
    2
  </button>
  <button v-else 
          @click="showAssignModal = true; prepareSlotForAssignment(date, slot.time, 2)" 
          class="slot-libero">
    2
  </button>
</div>
<div class="slot-grid-column">
  <button v-if="slot.isBooked[3]" 
          @click="mostraModale(date, slot.time, 3)" 
          :class="slot.isSpecial[3] ? 'slot-prenotato-special' : 'slot-prenotato'">
    3
  </button>
  <button v-else 
          @click="showAssignModal = true; prepareSlotForAssignment(date, slot.time, 3)" 
          class="slot-libero">
    3
  </button>
</div>



</div>


          </div>
        </div>
      </div>

      <div class="modal" v-if="showModal">
  <div class="modal-content">
    <div class="modal-columns">
      <!-- Colonna 1: Informazioni Utente -->
      <div class="modal-column-user">
        <h3>Utente</h3>
        <p>Tipo Utente: <strong>{{ selectedSlotInfo.tipoutente }}</strong></p>
        <p>C.F.: <strong>{{ selectedSlotInfo.codFiscale }}</strong></p>
        <p>Studio: <strong>{{ selectedSlotInfo.studio }}</strong></p>
        <p>Nome: <strong>{{ selectedSlotInfo.name }}</strong></p>
        <p>Cognome: <strong>{{ selectedSlotInfo.surname }}</strong></p>
        <p>Email: <strong>{{ selectedSlotInfo.email }}</strong></p>
        <p>Luogo di Nascita: <strong>{{ selectedSlotInfo.luogoNascita }}</strong></p>
        <p>Note utente: <strong>{{ selectedSlotInfo.notes }}</strong></p>
      </div>
      
      <!-- Colonna 2: Dettagli Prenotazione e Videocall -->
      <div class="modal-column-details">
        <h3>Dettagli prenotazione</h3>
        <p>Data: {{ selectedSlotInfo.data }}</p>
        <p>Orario: {{ selectedSlotInfo.orario }}</p>
        <h3>Dettagli Videocall</h3>
        <p>Videocall: </p>
        <select v-model="selectedSlotInfo.videocall" @change="updateVideocallStatus(selectedSlotInfo.id, selectedSlotInfo.videocall)">
          <option value="">Seleziona...</option>
          <option value="Fatta">Fatta</option>
          <option value="Annullata">Annullata</option>
          <option value="Spostata">Spostata</option>
        </select>
        <p>Nutrizionista: </p>
        <select v-model="selectedSlotInfo.nutrizionista" @change="updateNutrizionista(selectedSlotInfo.id, selectedSlotInfo.nutrizionista)">
          <option value="">Seleziona...</option>
          <option value="Martina">Martina</option>
          <option value="Francesca">Francesca</option>
        </select>
        <p>Tipo Utente: </p>
        <select v-model="selectedSlotInfo.tipoutente" @change="updateTipoUtente(selectedSlotInfo.id, selectedSlotInfo.tipoutente)">
          <option value="">Seleziona...</option>
          <option value="Nuovo">Nuovo</option>
          <option value="Rinnovo">Rinnovo</option>
        </select>
      </div>
    </div>
    <!-- Div per i bottoni, posizionato sotto le due colonne -->
    <div class="button-container">
      <button @click="showModal = false">Chiudi</button>
      <button @click="cancellaSlot(selectedSlotInfo.id)">Libera Slot</button>

      <button @click="viewUserDetails(selectedSlotInfo.userId)">Val al profilo</button>
      <button @click="openLink" class="button-link">Apri Link dropbox</button>

    </div>
  </div>
</div>




<div class="modal" v-if="showAssignModal">
  <div class="modal-content">
    <div class="modal-columns">
      <!-- Colonna per l'input e il messaggio -->
      <div class="modal-column-details">
        <h3>Assegna slot ad utente</h3>
        <input type="text" v-model="userEmail" placeholder="Inserisci email utente">
        <p v-if="showMessage">{{ message }}</p>
        <button class="staff-button-positive" v-if="message === 'Utente non esistente'" @click="goToUserList">Crea utente</button>
      </div>
    </div>
    <!-- Div per i bottoni -->
    <div class="button-container">
      <button @click="assegnaSlotAUtente">Assegna Slot</button>
      <button @click="bloccaSlotDefault">Blocca Slot</button> <!-- Nuovo bottone -->
      <button @click="showAssignModal = false; resetModal()">Chiudi</button>
    </div>
  </div>
</div>


    </div>
  </div>
</template>






<script>
  import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, setDoc, collection, query, where, getDocs, getDoc, deleteDoc, updateDoc } from 'firebase/firestore';
import SidebarComponent from '../SidebarComponent.vue';

export default {
  components: {
    SidebarComponent
  },
  setup() {
    const router = useRouter();
    const auth = getAuth();
    const db = getFirestore();
    const userId = ref(null);
    const slotsByDate = ref({});
    const currentAccordion = ref(null);
    const showModal = ref(false);
    const showAssignModal = ref(false);
    const selectedSlotInfo = ref({});
    const userEmail = ref('');
    const prenotazioniUtente = ref([]);
    const message = ref('');
    const showMessage = ref(false);
    const specialUserIds = ['HpMiFyBZnwX6EUf6VR9iCsHkqo82', 'VgzW5uCg6nedHLIJI4sJTW6o7xu1'];  // Sostituisci con gli ID reali

    


    const openLink = () => {
      const url = selectedSlotInfo.value.linkdrop;
      if (url) {
        window.open(url, '_blank');
      } else {
        alert('URL non disponibile o non valido.');
      }
    };


const viewUserDetails = (userId) => {
      router.push({ name: 'UserDetails', params: { userId: userId } });
    };
    

    
    const bloccaSlotDefault = async () => {
    const defaultEmail = 'valeriobianconi@gmail.com';
    const userQuery = query(collection(db, "users"), where("email", "==", defaultEmail));
    const userDocs = await getDocs(userQuery);

    if (userDocs.empty) {
      message.value = "Utente Valerio Bianconi non esistente";
      showMessage.value = true;
      setTimeout(() => showMessage.value = false, 3000);
      return;
    }

    const userIdToAssign = userDocs.docs[0].id;
    if (selectedSlotInfo.value.date && selectedSlotInfo.value.time) {
      try {
        await prenotaSlot(selectedSlotInfo.value.date, selectedSlotInfo.value.time, userIdToAssign);
        message.value = "Slot assegnato a Valerio Bianconi con successo";
        showAssignModal.value = false;
        resetModal();
      } catch (error) {
        message.value = "Errore, impossibile assegnare slot a Valerio Bianconi";
      }
      showMessage.value = true;
      setTimeout(() => showMessage.value = false, 3000);
    }
  };

    const calcolaSlotLiberi = (slots) => {
  let totaleSlotLiberi = 0;
  
  // Itera su ogni slot
  slots.forEach(slot => {
    // Itera su ogni possibile sotto-slot da 1 a 3
    for (let i = 1; i <= 3; i++) {
      if (!slot.isBooked[i]) {
        totaleSlotLiberi += 1;  // Aggiungi al contatore se il sotto-slot è libero
      }
    }
  });
  
  return totaleSlotLiberi;
};



    function resetModal() {
  userEmail.value = "";  // Resetta l'email dell'utente
  message.value = "";    // Cancella qualsiasi messaggio
  showMessage.value = false;  // Nasconde il messaggio
}


    async function cancellaSlot(slotId) {
  if (!slotId) {
    console.error("Slot ID non fornito");
    return;
  }

  try {
    const slotRef = doc(db, "prenotazioni", slotId);
    await deleteDoc(slotRef);
    showModal.value = false; // Chiude il modale dopo la cancellazione
    console.log(`Slot cancellato: ${slotId}`);
    await filterBookedSlots(); // Aggiorna la lista degli slot prenotati
  } catch (error) {
    console.error(`Errore nella cancellazione dello slot: ${slotId}`, error);
  }
}




    async function assegnaSlotAUtente() {
      const userQuery = query(collection(db, "users"), where("email", "==", userEmail.value));
      const userDocs = await getDocs(userQuery);

      if (userDocs.empty) {
        message.value = "Utente non esistente";
        showMessage.value = true;
        setTimeout(() => showMessage.value = false, 3000);
        return;
      }

      const userIdToAssign = userDocs.docs[0].id;
      if (selectedSlotInfo.value.date && selectedSlotInfo.value.time) {
        try {
          await prenotaSlot(selectedSlotInfo.value.date, selectedSlotInfo.value.time, userIdToAssign);
          message.value = "Slot assegnato con successo";
          showAssignModal.value = false;
          resetModal();  // Aggiungi qui il reset
        } catch (error) {
          message.value = "Errore, impossibile assegnare a questo utente";
        }
        showMessage.value = true;
        setTimeout(() => showMessage.value = false, 3000);
        userEmail.value = "";
      }
    }

    function prepareSlotForAssignment(date, time, slotNumber) {
      selectedSlotInfo.value = { date, time, slotNumber };
      showAssignModal.value = true;
    }



    async function prenotaSlot(date, time, userIdToAssign) {
  const slotBaseId = `slot_${date}_${time.replace(':', '')}`;
  const slotsQuery = query(collection(db, "prenotazioni"), where("id", ">=", slotBaseId), where("id", "<", slotBaseId + 'z'));
  const querySnapshot = await getDocs(slotsQuery);

  const bookedSlots = new Array(3).fill(false); // Solo 3 slot ora
  querySnapshot.forEach(doc => {
    const suffix = parseInt(doc.id.split('_').pop());
    bookedSlots[suffix - 1] = true; 
  });

  const newProgressive = bookedSlots.indexOf(false) + 1; 
  if (newProgressive === 0) { 
    alert("Questo slot è già stato prenotato 3 volte.");
    return;
  }

  const newSlotId = `${slotBaseId}_${newProgressive}`;
  const newSlotRef = doc(db, "prenotazioni", newSlotId);
  await setDoc(newSlotRef, {
    id: newSlotId,
    userId: userIdToAssign,
    data: date,
    orario: time,
    stato: 'Booked'
  });

  await filterBookedSlots(); 
}








function goToUserList() {
      router.push('/users-list'); // Utilizza il metodo push di Vue Router per cambiare pagina
    }


async function mostraModale(date, time, slotNumber) {
  const slotId = `slot_${date}_${time.replace(':', '')}_${slotNumber}`;
  const docRef = doc(db, "prenotazioni", slotId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const slotData = docSnap.data();
    // Ora recupera le informazioni dell'utente basate su slotData.userId
    const userRef = doc(db, "users", slotData.userId);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      const userData = userSnap.data();
      // Combina le informazioni dello slot con quelle dell'utente
      selectedSlotInfo.value = {
        ...slotData, // Informazioni esistenti dello slot
        name: userData.name, // Aggiungi il nome
        surname: userData.surname, // Aggiungi il cognome
        email: userData.email, // Aggiungi l'email
        codFiscale: userData.codFiscale,
        luogoNascita: userData.luogoNascita,
        notes: userData.notes,
        linkdrop: userData.linkdrop,
        studio: userData.studio,

      };
    } else {
      console.log("Nessuna informazione utente trovata per l'ID fornito.");
    }

    showModal.value = true;
  } else {
    console.log("Nessuna informazione trovata per lo slot selezionato.");
  }
}






    function formattaData(dataInput) {
      let [anno, mese, giorno] = dataInput.split('-');
      if (anno && anno.length === 4) {
        return `${giorno.padStart(2, '0')}-${mese.padStart(2, '0')}-${anno}`;
      } else {
        return dataInput; // Gestisce il caso in cui la data sia già nel formato desiderato
      }
    }


    async function cancellaPrenotazioniGiorno(date) {
  // Query per trovare tutte le prenotazioni per la data specificata
  const slotsQuery = query(collection(db, "prenotazioni"), where("data", "==", date));
  const querySnapshot = await getDocs(slotsQuery);
  
  // Cancellazione di ogni prenotazione trovata
  const cancellazioni = querySnapshot.docs.map(async (doc) => {
    const prenotazioneRef = doc.ref;
    await deleteDoc(prenotazioneRef);
  });
  
  // Attesa della conclusione di tutte le cancellazioni
  await Promise.all(cancellazioni);

  // Opzionalmente, ricarica le prenotazioni o aggiorna lo stato dell'UI
  await caricaPrenotazioni();
  await filterBookedSlots();
}



async function bloccaGiornoIntero(date) {
  const slotsQuelGiorno = slotsByDate.value[date];
  if (!slotsQuelGiorno) {
    console.log("Nessuno slot disponibile per questa data.");
    return;
  }

  let slotsBloccati = 0;
  const promises = [];

  for (const slot of slotsQuelGiorno) {
    // Blocca slot 1, 2 e 3 in parallelo se disponibili
    promises.push(prenotaSlotSeDisponibile(date, slot.time, 1));
    promises.push(prenotaSlotSeDisponibile(date, slot.time, 2));
    promises.push(prenotaSlotSeDisponibile(date, slot.time, 3));
  }

  // Attendi che tutte le prenotazioni siano completate
  const results = await Promise.all(promises);

  // Conta gli slot bloccati con successo
  slotsBloccati = results.filter(success => success === true).length;

  if (slotsBloccati > 0) {
    // Mostra l'alert dopo aver bloccato gli slot
    alert("Giorno bloccato, ricarica la pagina per aggiornare lo stato.");
  } else {
    console.log("Nessuno slot è stato bloccato.");
  }
}

async function prenotaSlotSeDisponibile(date, time, slotNumber) {
  const slotId = `slot_${date}_${time.replace(':', '')}_${slotNumber}`;
  const docRef = doc(db, "prenotazioni", slotId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    console.log(`Slot ${slotNumber} alle ${time} per la data ${date} è già prenotato.`);
    return false;  // Slot già prenotato, quindi non lo prenota di nuovo
  }

  // Prenota lo slot se è disponibile
  await setDoc(docRef, {
    id: slotId,
    userId: userId.value,
    data: date,
    orario: time,
    stato: 'Booked'
  });

  return true;  // Slot bloccato con successo
}



async function bloccaGiorno1slot(date) {
  const slotsQuelGiorno = slotsByDate.value[date];
  if (!slotsQuelGiorno) {
    console.log("Nessuno slot disponibile per questa data.");
    return;
  }

  let slotsBloccati = 0;
  for (const slot of slotsQuelGiorno) {
    // Blocca solo il primo slot disponibile (1, 2 o 3) per ogni fascia oraria
    const success = await prenotaPrimoSlotDisponibile(date, slot.time);
    if (success) {
      slotsBloccati++;  // Conta gli slot bloccati
      console.log(`Slot bloccato per l'orario ${slot.time}`);
    }
  }

  if (slotsBloccati > 0) {
    // Mostra l'alert dopo aver bloccato gli slot
    alert("Slot bloccati, ricarica la pagina per aggiornare lo stato.");
  } else {
    console.log("Nessuno slot è stato bloccato.");
  }
}


async function bloccaFasciaOraria1slot(date) {
  const slotsQuelGiorno = slotsByDate.value[date];
  if (!slotsQuelGiorno) {
    console.log("Nessuno slot disponibile per questa data.");
    return;
  }

  let slotsBloccati = 0;

  // Filtra gli slot tra le 08:00 e le 11:30
  const slotsFasciaOraria = slotsQuelGiorno.filter(slot => {
    const orario = parseInt(slot.time.replace(':', ''));
    return orario >= 800 && orario <= 1130;
  });

  for (const slot of slotsFasciaOraria) {
    // Blocca solo il primo slot disponibile (1, 2 o 3) per ciascun orario
    const success = await prenotaPrimoSlotDisponibile(date, slot.time);
    if (success) {
      slotsBloccati++;  // Conta gli slot bloccati
      console.log(`Slot bloccato per l'orario ${slot.time}`);
    }
  }

  if (slotsBloccati > 0) {
    alert(`Bloccati ${slotsBloccati} slot tra le 08:00 e le 11:30.`);
  } else {
    console.log("Nessuno slot è stato bloccato nella fascia oraria specificata.");
  }
}





async function prenotaPrimoSlotDisponibile(date, time) {
  const slotBaseId = `slot_${date}_${time.replace(':', '')}`;
  const slotsQuery = query(collection(db, "prenotazioni"), where("id", ">=", slotBaseId), where("id", "<", slotBaseId + 'z'));
  const querySnapshot = await getDocs(slotsQuery);

  const bookedSlots = new Array(3).fill(false); // Solo 3 slot per orario
  querySnapshot.forEach(doc => {
    const suffix = parseInt(doc.id.split('_').pop());
    bookedSlots[suffix - 1] = true; 
  });

  const newProgressive = bookedSlots.indexOf(false) + 1; 
  if (newProgressive === 0) { 
    console.log("Tutti gli slot per questo orario sono già prenotati.");
    return false;
  }

  const newSlotId = `${slotBaseId}_${newProgressive}`;
  await setDoc(doc(db, "prenotazioni", newSlotId), {
    id: newSlotId,
    userId: userId.value,
    data: date,
    orario: time,
    stato: 'Booked'
  });

  return true;
}







    async function caricaPrenotazioni() {
      if (!userId.value) return;
      const q = query(collection(db, "prenotazioni"), where("userId", "==", userId.value));
      const querySnapshot = await getDocs(q);
      prenotazioniUtente.value = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    }


    async function filterBookedSlots() {
  let generatedSlots = generateSlotsForWeek();
  const slotsCollection = collection(db, 'prenotazioni');
  const q = query(slotsCollection, where('stato', '==', 'Booked'));
  const querySnapshot = await getDocs(q);

  let bookedSlots = {};
  querySnapshot.forEach((doc) => {
    const docData = doc.data();
    const slotIdBase = `slot_${docData.data}_${docData.orario.replace(':', '')}`;
    let suffix = doc.id.split('_').pop();
    if (!bookedSlots[slotIdBase]) {
      bookedSlots[slotIdBase] = { suffixes: [], specialBookings: [] };
    }
    bookedSlots[slotIdBase].suffixes.push(parseInt(suffix));
    if (specialUserIds.includes(docData.userId)) {
      bookedSlots[slotIdBase].specialBookings.push(parseInt(suffix));
    }
  });

  // continua con la logica di assegnazione per `slotsByDate.value`
  for (const date in generatedSlots) {
    slotsByDate.value[date] = generatedSlots[date].map(slot => {
      const slotIdBase = `slot_${date}_${slot.time.replace(':', '')}`;
      let isBookedArray = bookedSlots[slotIdBase] ? bookedSlots[slotIdBase].suffixes : [];
      let isSpecialBooking = bookedSlots[slotIdBase] ? bookedSlots[slotIdBase].specialBookings : [];
      let isBooked = {
        1: isBookedArray.includes(1),
        2: isBookedArray.includes(2),
        3: isBookedArray.includes(3),
        4: isBookedArray.includes(4)
      };
      let isSpecial = {
        1: isSpecialBooking.includes(1),
        2: isSpecialBooking.includes(2),
        3: isSpecialBooking.includes(3),
        4: isSpecialBooking.includes(4)
      };
      return { ...slot, isBooked, isSpecial };
    });
  }
}



const updateVideocallStatus = async (slotId, newVideocallStatus) => {
  const db = getFirestore();

  try {
    // Crea un riferimento al documento specifico nello slotId fornito
    const slotRef = doc(db, 'prenotazioni', slotId);
    
    // Aggiorna il campo 'videocall' del documento specificato
    await updateDoc(slotRef, {
      videocall: newVideocallStatus,
    });

    console.log(`Stato videocall aggiornato con successo per: ${slotId}`);
  } catch (error) {
    console.error(`Errore nell'aggiornamento dello stato della videocall per: ${slotId}`, error);
  }
};


const updateNutrizionista = async (slotId, newNutrizionista) => {
  const db = getFirestore();

  try {
    // Crea un riferimento al documento specifico nello slotId fornito
    const slotRef = doc(db, 'prenotazioni', slotId);
    
    // Aggiorna il campo 'videocall' del documento specificato
    await updateDoc(slotRef, {
      nutrizionista: newNutrizionista,
        });

    console.log(`Stato videocall aggiornato con successo per: ${slotId}`);
  } catch (error) {
    console.error(`Errore nell'aggiornamento dello stato della videocall per: ${slotId}`, error);
  }
};


const updateTipoUtente = async (slotId, TipoUtente) => {
  const db = getFirestore();

  try {
    // Crea un riferimento al documento specifico nello slotId fornito
    const slotRef = doc(db, 'prenotazioni', slotId);
    
    // Aggiorna il campo 'videocall' del documento specificato
    await updateDoc(slotRef, {
      tipoutente: TipoUtente,
        });

    console.log(`Stato videocall aggiornato con successo per: ${slotId}`);
  } catch (error) {
    console.error(`Errore nell'aggiornamento dello stato della videocall per: ${slotId}`, error);
  }
};


const generateSlotsForWeek = () => {
  let slots = {};
  let now = new Date();
  for (let i = 0; i < 30; i++) { // Cicla solo per i prossimi 7 giorni
    let tempDate = new Date(now);
    tempDate.setDate(now.getDate() + i);

    // Salta la generazione degli slot se il giorno è sabato (6) o domenica (0)
    if (tempDate.getDay() !== 6 && tempDate.getDay() !== 0) {
      let dateString = tempDate.toISOString().split('T')[0];
      slots[dateString] = [];
      for (let hour = 8; hour <= 18; hour += 0.5) {
        const fullHour = Math.floor(hour);
        const minutes = (hour % 1 === 0.5) ? '30' : '00';
        const timeString = `${fullHour.toString().padStart(2, '0')}:${minutes}`;
        // Aggiunge lo slot alla lista se non è sabato o domenica
        slots[dateString].push({ time: timeString, isBooked: 0 });
      }
    }
  }
  return slots;
};







async function prenota(date, time) {
  if (!userId.value) {
    alert("Nessun utente autenticato.");
    return;
  }

  const slotBaseId = `slot_${date}_${time.replace(':', '')}`;
  const slotsQuery = query(collection(db, "prenotazioni"), where("id", ">=", slotBaseId), where("id", "<", slotBaseId + 'z'));
  const querySnapshot = await getDocs(slotsQuery);

  const bookedSlots = new Array(4).fill(false); // Array di 4 slot, tutti inizialmente impostati a false
  querySnapshot.forEach(doc => {
    const suffix = parseInt(doc.id.split('_').pop());
    bookedSlots[suffix - 1] = true;  // Marca l'indice come prenotato
  });

  const newProgressive = bookedSlots.indexOf(false) + 1; // Trova il primo slot non prenotato
  if (newProgressive === 0) { // Se non ci sono slot disponibili
    alert("Questo slot è già stato prenotato 4 volte.");
    return;
  }

  const newSlotId = `${slotBaseId}_${newProgressive}`;

  const newSlotRef = doc(db, "prenotazioni", newSlotId);
  const docSnap = await getDoc(newSlotRef);
  if (docSnap.exists()) {
    alert("Errore di prenotazione, per favore riprova.");
    return;
  }

  await setDoc(newSlotRef, {
    id: newSlotId,
    userId: userId.value,
    data: date,
    orario: time,
    stato: 'Booked'
  });

  await caricaPrenotazioni();
  await filterBookedSlots();
}







    const toggleAccordion = (date) => {
      currentAccordion.value = currentAccordion.value === date ? null : date;
    };

    onMounted(async () => {
      if (auth.currentUser) {
        userId.value = auth.currentUser.uid;
        await caricaPrenotazioni();
        await filterBookedSlots();
      }
    });

    return { slotsByDate, currentAccordion, prenota, toggleAccordion, formattaData, bloccaGiornoIntero, cancellaPrenotazioniGiorno, mostraModale, showModal,
      selectedSlotInfo, updateNutrizionista, showAssignModal,
      userEmail, assegnaSlotAUtente, prepareSlotForAssignment, prenotaSlot,message, showMessage, goToUserList, updateVideocallStatus, updateTipoUtente,cancellaSlot, resetModal, bloccaGiorno1slot, calcolaSlotLiberi, bloccaFasciaOraria1slot,
      viewUserDetails, openLink, bloccaSlotDefault, prenotazioniUtente, // Assicurati di ritornare questa variabile se la usi nel template
};
  },
  methods: {
      goBack() {
        this.$router.go(-1);
      },
    }
};
</script>









<style scoped>


.special-booking {
  background-color: rgb(146, 0, 0) !important;
  color: white !important;
}




.slots-prenotati {
  background-color: #007bff; /* Blu */
  color: white;
  padding: 3px 6px;
  border-radius: 5px;
  margin-left: 10px;
}

.button-container {
  text-align: left; /* Centra i bottoni */
  width: 100%; /* Estende il div per tutta la larghezza del contenitore padre */
}

.button-container button {
  margin: 0 10px; /* Distanza tra i bottoni */
  padding: 10px 20px; /* Più spazio all'interno dei bottoni */
  background-color: #4A90E2; /* Colore di sfondo */
  color: white; /* Colore del testo */
  border: none; /* Rimuove il bordo */
  border-radius: 25px; /* Bordi arrotondati */
  cursor: pointer; /* Cambia il cursore in un puntatore */
  transition: background-color 0.3s; /* Transizione per l'hover */
}

.button-container button:hover {
  background-color: #357ABD; /* Cambia il colore di sfondo al passaggio del mouse */
}


.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  background-color: #303030;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  width: 60%; /* Aggiustato per contenere entrambe le colonne */
  max-width: 100%;
  margin-left: 230px;
}

.modal-columns {
  display: flex;
  width: 100%;
  justify-content: space-between; /* Distanza tra le colonne */
}

.modal-column-user, .modal-column-details {
  flex: 1; /* Assicura che ogni colonna occupi metà dello spazio disponibile */
  margin: 10px;
  padding: 30px;
  background-color: #373737; /* Differenzia le colonne con un colore di sfondo leggermente diverso */
  border-radius: 5px; /* Bordi arrotondati per ciascuna colonna */
}

.sold-out {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}

.slot-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 colonne per includere i 4 slot */
  gap: 16px; /* Spazio tra le colonne */
}

.slot-grid-row {
  display: flex;
  justify-content: space-around; /* Distribuisce equamente i bottoni */
  align-items: center;
  background-color: #e0e0e0;
  padding: 10px;
  border-radius: 8px; /* Arrotonda i bordi della riga */
  margin-bottom: 10px; /* Distanza tra le righe */
}


.slot-grid-column {
  text-align: center; /* Allinea il testo al centro */
margin-left: 5px;
}

.slot-prenotato {
  background-color: red; /* Sfondo per slot prenotati */
  color: white;
  width: 40px; /* Imposta una larghezza fissa per i bottoni */
  height: 40px; /* Imposta una altezza fissa per i bottoni */
  border-radius: 50%; /* Rende i bottoni circolari */
  border: none;
  font-size: 18px; /* Testo più grande e visibile */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.slot-prenotato-special {
  background-color: rgb(60, 60, 60); /* Colore per le prenotazioni speciali */
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.slot-prenotato-special:hover {
  background-color: darkpurple; /* Colore al passaggio del mouse */
}



.slot-prenotato:hover {
  background-color: darkred; /* Cambia il colore al passaggio del mouse */
}

.slot-libero {
  background-color: green; /* Sfondo per slot liberi */
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.slot-libero:hover {
  background-color: darkgreen; /* Cambia il colore al passaggio del mouse */
}

.slot-grid-row {
  display: flex;
  justify-content: space-around; /* Distribuisce equamente i bottoni */
  align-items: center;
  background-color: #e0e0e0;
  padding: 10px;
  border-radius: 8px; /* Arrotonda i bordi della riga */
  margin-bottom: 10px; /* Distanza tra le righe */
}

p {
  color:#e4e4e4
}

.titolo-card h3{
  color:rgb(228, 0, 0)
}
/* Stilizzazione generale per desktop, che verrà sovrascritta per mobile se necessario */

</style>

  